import React from "react";
import { useHasPermission } from "../../hooks/useHasPermission";

export function PermissionGate({ code, children }: { code: string; children: React.ReactNode }) {
  return useHasPermission(code) ? <>{children}</> : null;
}
